import { useEffect } from "react";
import Tabs from "../../../../../../components/Basic/Tabs";
import { getStore } from "../../../../../../util/store/store";
import { OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import { IOperation, IVessel } from "../../../../../../util/varibles/interface";
import { selectPlan } from "../../../../constants";
import { getEditOp, IVesselOfMain, useEditOp } from "../../EditOperationContext";
import Calendar from "./Calendar";
import styles from "./style.module.scss";
import { IMainOp, useSupportOperation } from "./SupportOpContext";
import Vessels from "./Vessels";

export const initVesselOfMainOp = (vessel: IVessel, ops?: IOperation[]) => {
    return { id: vessel.id, name: vessel.name, checked: true, ops }
}

const getSubsOfMainOp = (mainId: string): { [id: string]: IVesselOfMain } => {
    const rootOps = selectPlan.ops(getStore());
    let result: { [id: string]: IVesselOfMain } = {};
    Object.keys(rootOps).forEach(key => {
        const { id, related_id } = rootOps[key].operation;
        if (id !== mainId && mainId === related_id) {
            const { id: vesselId } = rootOps[key].vessel;
            if (!result[vesselId]) {
                result = { ...result, [vesselId]: initVesselOfMainOp(rootOps[key].vessel, [rootOps[key]]) }
            } else {
                result = { ...result, [vesselId]: { ...result[vesselId], ops: [...result[vesselId].ops || [], rootOps[key]] } }
            }
        }
    });

    return result;
}

interface IResultGenerateOps {
    mainOps?: { [id: string]: IMainOp }
    supportOperations?: {
        [id: string]: {
            [id: string]: IVesselOfMain
        }
    }
}

const generateOps: { [id: string]: (get: ReturnType<typeof getEditOp>) => IResultGenerateOps } = {
    [OPERATION_TYPE.TREATMENT]: (get) => {
        const { operation, activity_log } = get();
        if (!operation || activity_log.length === 0) {
            return {};
        } else {
            const { id } = operation;
            const mainOps = {
                [operation.id]: {
                    name: `Trip ${operation.operation_code}`,
                    data: {
                        operation,
                        start: activity_log[0].est_start_time || 0,
                        finish: activity_log[activity_log.length - 1].est_finish_time
                            || activity_log[activity_log.length - 1].est_start_time || 0,
                        type: operation.operation_type
                    }
                }
            }
            return {
                mainOps,
                supportOperations: {
                    [id]: getSubsOfMainOp(id)
                }
            };
        }
    },
    [OPERATION_TYPE.HARVEST]: (get) => {
        const { harvests } = get();
        if (!harvests) {
            return {};
        } else {
            let supportOperations: { [id: string]: { [id: string]: IVesselOfMain } } = {};
            const mainOps = harvests.reduce((rs: { [id: string]: IMainOp }, op) => {
                const { id, operation_code, operation_type } = op.operation;
                const { activity_log = [] } = op;
                if (activity_log.length === 0)
                    return rs;
                rs[id] = {
                    name: `Trip ${operation_code}`,
                    data: {
                        operation: op.operation,
                        start: activity_log[0].est_start_time || 0,
                        finish: activity_log[activity_log.length - 1].est_finish_time
                            || activity_log[activity_log.length - 1].est_start_time || 0,
                        type: operation_type
                    }
                };
                supportOperations = { ...supportOperations, [id]: getSubsOfMainOp(id) };
                return rs;
            }, {})
            return {
                mainOps,
                supportOperations
            };
        }
    },
}

const MainOperation: React.FC<{ data?: IMainOp['data'] }> = ({ data }) => {
    if (!data)
        return null;

    return <div className={styles.mainOperation}>
        <Calendar mainOp={data} />
        <Vessels mainOp={data} />
    </div>;
}

const SupportOp: React.FC = () => {
    const [supportMode, setEditOp] = useEditOp(state => state.supportMode);
    const getOp = getEditOp();
    const [mainOps = {}, setSupport] = useSupportOperation(state => state.mainOps);

    useEffect(() => {
        if (supportMode) {
            const { opType, vessel } = getOp();
            if (opType !== undefined && vessel) {
                const { mainOps = {}, supportOperations = {} } = generateOps[opType]?.(getOp) || {};
                setSupport({ mainOps });
                setEditOp({ supportOperations })
            }
        }
    }, [getOp, setEditOp, setSupport, supportMode]);

    return <div className={styles.supportOp} data-visible={supportMode}>
        {Object.keys(mainOps).length > 0 && <Tabs opts={Object.keys(mainOps).map(id => mainOps[id])}>
            <MainOperation />
        </Tabs>}
    </div >
}

export default SupportOp;
